import React, { useCallback, useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../../config";

const PrintButton = ({ quoteId }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handlePrint = useCallback(async () => {
        setLoading(true);
        try {
            const resp = await axios.get(`/quotes/${quoteId}/pdf`);
            window.open(config.baseURL + "/" + resp.data.file_path, "_blank");
        } catch (e) {
            console.error(e);
            toast.error(t("Error while printing"));
        } finally {
            setLoading(false);
        }
    }, [quoteId, t]);

    return (
        <Button className="ms-2" color="secondary" onClick={handlePrint}>
                <>
                {loading ? <i className="la la-spinner la-spin" /> : <i className="fa fa-print"></i>}
                <span className="ms-2">{t("Print avtal")}</span>
                     
                </>
        
        </Button>
    );
};

export default PrintButton;